// Groups a flat, code-ordered list of reference items into category
// buckets, preserving first-seen order of each category. Defaults to the
// `category_group` field (ICD-10 reference lists) but accepts a custom
// accessor for other reference tables (e.g. procedure_catalog's `category`).
export interface Icd10CategoryGroup<T> {
  category: string;
  items: T[];
}

export function groupByCategory<T>(
  items: T[],
  getCategory: (item: T) => string = (item) => (item as unknown as { category_group: string }).category_group
): Icd10CategoryGroup<T>[] {
  const groups: Icd10CategoryGroup<T>[] = [];
  const indexByCategory = new Map<string, number>();

  items.forEach((item) => {
    const key = getCategory(item);
    let idx = indexByCategory.get(key);

    if (idx === undefined) {
      idx = groups.length;
      indexByCategory.set(key, idx);
      groups.push({ category: key, items: [] });
    }

    groups[idx].items.push(item);
  });

  return groups;
}
